import { mediaItems } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            精彩视频
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            精选吃瓜视频内容
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {mediaItems.map((item, idx) => (
            <div
              key={idx}
              className="group rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/15 group-hover:bg-black/25 transition-colors duration-300"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-14 h-14 flex items-center justify-center rounded-full bg-white/90 group-hover:bg-white group-hover:scale-110 transition-all duration-300">
                    <i className="ri-play-fill text-accent-500 text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 text-xs px-2 py-0.5 rounded bg-black/60 text-white font-medium">
                  {item.duration}
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-heading font-semibold text-foreground-900 mb-1 group-hover:text-accent-600 transition-colors duration-200 line-clamp-1">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-1 mb-2">
                  {item.desc}
                </p>
                <div className="flex items-center gap-3 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}